import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('contractor_os_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('contractor_os_token');
      localStorage.removeItem('contractor_os_user');
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  }
);

export const auth = {
  signup: (data) => api.post('/auth/signup', data),
  verifyOtp: (data) => api.post('/auth/verify-otp', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
};

export const dashboard = {
  stats: () => api.get('/dashboard/stats'),
};

export const tenders = {
  list: (params) => api.get('/tenders', { params }),
  create: (data) => api.post('/tenders', data),
  update: (id, data) => api.put(`/tenders/${id}`, data),
  remove: (id) => api.delete(`/tenders/${id}`),
  parseDocument: (data) => api.post('/tenders/parse-document', data),
  summarize: (data) => api.post('/tenders/summarize', data),
  searchBid: (data) => api.post('/tenders/search-bid', data),
  convertToProject: (id) => api.post(`/tenders/${id}/convert-to-project`),
  analyzeBid: (data) => api.post('/tenders/analyze-bid', data),
  generatePdf: (data) => api.post('/tenders/generate-pdf', data),
};

export const projects = {
  list: () => api.get('/projects'),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  remove: (id) => api.delete(`/projects/${id}`),
};

export const workers = {
  list: () => api.get('/workers'),
  create: (data) => api.post('/workers', data),
  update: (id, data) => api.put(`/workers/${id}`, data),
  remove: (id) => api.delete(`/workers/${id}`),
  attendance: (id, data) => api.post(`/workers/${id}/attendance`, data),
  bulkImport: (data) => api.post('/workers/bulk-import', data),
  bulkConfirm: (data) => api.post('/workers/bulk-confirm', data),
};

export const finance = {
  list: (params) => api.get('/finance', { params }),
  create: (data) => api.post('/finance', data),
  remove: (id) => api.delete(`/finance/${id}`),
  summary: () => api.get('/finance/summary'),
};

export const documents = {
  list: (params) => api.get('/documents', { params }),
  create: (data) => api.post('/documents', data),
  download: (id) => api.get(`/documents/${id}/download`),
  remove: (id) => api.delete(`/documents/${id}`),
};

export const settings = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
};

export const niches = {
  list: () => api.get('/niches'),
};

export const plan = {
  get: () => api.get('/plan'),
  check: (feature) => api.post(`/plan/check?feature=${feature}`),
};

export default api;
